import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input } from 'reactstrap';
import moment from 'moment';
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { getRegs, insert, selectValues, update } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import powerAppsApi from '../../../services/powerapps';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { notifyError, notifySuccess } from '../../../utils/notify';

const ModalFormEdicaoFavBordero = ( props ) => {

  const [addFavModal, setAddFavModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [identificador, setIdentificador] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [numeroConta, setNumeroConta] = useState('');
  const [pix, setPix] = useState('');
  const [tipoPix, setTipoPix] = useState({});
  const [kaminoId, setKaminoId] = useState('');
  const [telefoneFixo, setTelefoneFixo] = useState('');
  const [celular, setCelular] = useState('');
  const [selectTipoPix, setSelectTipoPix] = useState([]);


  const handleClickOpenAddFavModal = async () => {
    setAddFavModal(true);
    setIsLoading(true);
    try {
      await preloading();
    } finally {
      setIsLoading(false);
    }
  };
  const handleClickCloseAddFavModal = () => setAddFavModal(false);

  const verificaIdentificador = async (isPf) => {
    var exists = false;

    const info = isPf ? await getRegs('pf', {pf_id: props.fav.value}) : await getRegs('pj', {pj_id: props.fav.value});

    if (isPf && info[0].pf_cpf !== identificador) {

      const pf = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_cpf: identificador,
        }
      })}`);

      if (pf.data[0]) {
        exists = true
      };
    }

    else if (!isPf && info[0].pj_cnpj !== identificador) {

      const pj = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: {
          pj_cnpj: identificador,
        }
      })}`);

      if (pj.data[0]) {
        exists = true
      };
    }

    return exists;
  }

  function checkCamposObrigatoriosContrForn() {

    if (!props.isPf) {
      if ( !nome || nome.trim() === '') {
        notifyError('Nome é obrigatório');
        return false
      }

      if (!email || email.trim() === '') {
        notifyError('E-mail é obrigatório');
        return false
      }

      if (!identificador || String(identificador).trim() === '') {
        notifyError('CPF/CNPJ é obrigatório');
        return false
      }

      if (!telefoneFixo || telefoneFixo.trim() === '') {
        notifyError('Telefone é obrigatório');
        return false
      }

      if (telefoneFixo?.length < 9) {
        notifyError('Telefone incompleto');
        return false
      }
    } else if (props.isPf) {
      if (!nome || nome.trim() === '') {
        notifyError('Nome é obrigatório');
        return false
      }

      if (!email || email.trim() === '') {
        notifyError('E-mail é obrigatório');
        return false
      }

      if (!identificador || String(identificador).trim() === '') {
        notifyError('CPF/CNPJ é obrigatório');
        return false
      }

      if ((!celular || celular.trim() === '') && (!telefoneFixo || telefoneFixo === '')) {
        notifyError('Preencha o campo de telefone fixo ou celular');
        return false
      }

      if ((celular?.length < 9) || (telefoneFixo?.length < 9)) {
        notifyError('Telefone incompleto');
        return false
      }
    }

    return true
  }

  const handleSubmit = async () => {
    setIsLoading(true);

    const existFav = await verificaIdentificador(props.isPf);
    if (existFav) return alert('Favorecido já existe');

    const camposOk = checkCamposObrigatoriosContrForn();
    if (!camposOk) {
      setIsLoading(false);
      return;
    }

    if (props.isPf) {

      if ((!celular || celular === '') && (!telefoneFixo || telefoneFixo === '')) {
        setIsLoading(false);
        return alert('Preencha telefone fixo ou celular');
      }

      const pfBody = {
        pf_nomeExibicao: nome,
        pf_emailProf: email,
        pf_cpf: identificador,
        pf_contaBanco: banco,
        pf_contaAgencia: agencia,
        pf_contaNum: numeroConta,
        pf_chavePix: pix,
        pixTp_id: tipoPix.value,
        kamino_id: kaminoId || undefined,
        pf_telFixoProf: telefoneFixo ? String(telefoneFixo).trim() : undefined,
        pf_celProf: celular ? celular.trim() : undefined,
      }

      const pfUpdated = await update('pf', props.fav.value, pfBody);

      const kaminoBody = {
        acao: 'kamino_salvar_pessoa',
        table: 'pf',
        id: pfUpdated,
      }

      const res = await powerAppsApi.post('/', kaminoBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      if (res.status === 200) {
        notifySuccess('Informações enviadas para o banco!');
      }

    } else {

      if (!telefoneFixo || telefoneFixo === '') {
        setIsLoading(false);
        return alert('Preencha o campo de telefone');
      }

      console.log(telefoneFixo);

      const pjBody = {
        pj_nomefanta: nome,
        pj_emailPrin: email,
        pj_cnpj: identificador,
        pj_contaBanco: banco,
        pj_contaAgencia: agencia,
        pj_contaNum: numeroConta,
        pj_chavePix: pix,
        pixTp_id: tipoPix.value,
        pj_telPrin: telefoneFixo ? String(telefoneFixo).trim() : undefined,
        kamino_id: kaminoId || undefined,
      }
      const pjUpdated = await update('pj', props.fav.value, pjBody)

      const kaminoBody = {
        acao: 'kamino_salvar_pessoa',
        table: 'pj',
        id: pjUpdated,
      }

      const res = await powerAppsApi.post('/', kaminoBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      if (res.status === 200) {
        notifySuccess('Informações enviadas para o banco!');
      }

    }

    setIsLoading(false);

    if (typeof props.getFavs === 'function') {
      await props.getFavs(props.isPf);
    }

    if (typeof props.onFavSaved === 'function') {
      await props.onFavSaved(props.fav.value);
    } else if (typeof props.setFavInfo === 'function') {
      const fresh = props.isPf
        ? await getRegs('pf', { pf_id: props.fav.value })
        : await getRegs('pj', { pj_id: props.fav.value })
      props.setFavInfo((Array.isArray(fresh) && fresh[0]) || {})
    }

    handleClickCloseAddFavModal();
  }

  const preloading = async () => {
    if (!props.fav?.value) return

    const getSelectTipoPix = await selectValues('pixTp', 'pixTp_id', 'pixTp_nome', { pixTp_ativo: 1 })
    setSelectTipoPix(getSelectTipoPix || [])

    const info = props.isPf
      ? await getRegs('pf', { pf_id: props.fav.value })
      : await getRegs('pj', { pj_id: props.fav.value })

    const row = Array.isArray(info) ? info[0] : null
    if (!row) {
      notifyError('Não foi possível carregar os dados do favorecido no banco.')
      setNome('')
      setEmail('')
      setIdentificador('')
      setBanco('')
      setAgencia('')
      setNumeroConta('')
      setPix('')
      setTipoPix({})
      setKaminoId('')
      setTelefoneFixo('')
      setCelular('')
      return
    }

    if (props.isPf) {
      setNome(row.pf_nomeExibicao || '')
      setEmail(row.pf_emailProf || '')
      setIdentificador(row.pf_cpf || '')
      setBanco(row.pf_contaBanco || '')
      setAgencia(row.pf_contaAgencia || '')
      setNumeroConta(row.pf_contaNum || '')
      setPix(row.pf_chavePix || '')
      setKaminoId(row.kamino_id || '')
      setTelefoneFixo(row.pf_telFixoProf || '')
      setCelular(row.pf_celProf || '')
    } else {
      setNome(row.pj_nomefanta || '')
      setEmail(row.pj_emailPrin || '')
      setIdentificador(row.pj_cnpj || '')
      setBanco(row.pj_contaBanco || '')
      setAgencia(row.pj_contaAgencia || '')
      setNumeroConta(row.pj_contaNum || '')
      setPix(row.pj_chavePix || '')
      setKaminoId(row.kamino_id || '')
      setTelefoneFixo(row.pj_telPrin || '')
      setCelular('')
    }

    if (row.pixTp_id != null) {
      const found = (getSelectTipoPix || []).find(
        (e) => String(e.value) === String(row.pixTp_id),
      )
      setTipoPix(found || {})
    } else {
      setTipoPix({})
    }
  }

  useEffect(() => {
    if (props.fav?.value && addFavModal) {
      preloading()
    }
  }, [props.fav, props.isPf, addFavModal])

  return (
    <>
      <Btn
        size="sm"
        color="link"
        className="ml-2 px-0"
        onClick={(e)=>{
          e.preventDefault();
          handleClickOpenAddFavModal();
        }}
      >
        Editar {(props.isPf) ?  'PF' : 'PJ' }
      </Btn>
      {(props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Editar {(props.isPf) ?  'PF' : 'PJ' }
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Nome
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CPF
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
              <Label>
                Telefone fixo
              </Label>
              <Input
                value={telefoneFixo}
                onChange={e => setTelefoneFixo(String(e.target.value))}
              />
              <Label>
                Celular
              </Label>
              <Input
                value={celular}
                onChange={e => setCelular(String(e.target.value))}
              />
              <Label>
                Código do banco
              </Label>
              <Input
                type='number'
                value={banco}
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Identificação Kamino
              </Label>
              <Input
                type='number'
                value={kaminoId}
                onChange={e => setKaminoId(e.target.value)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn type="button" disabled><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  //insOrUp( 'projStake', addStakeProjData)
                  await handleSubmit()
                }
                }
              >
                Editar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
      {(!props.isPf) &&
        <Mdl
          centered={false}
          isOpen={addFavModal}
          toggle={handleClickCloseAddFavModal}
          zIndex={10000}
        >
          <ModalHeader
          >
            Adicionar
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Nome Fantasia
              </Label>
              <Input
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
              <Label>
                E-mail
              </Label>
              <Input
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <Label>
                CNPJ
              </Label>
              <Input
                value={identificador}
                onChange={e => setIdentificador(e.target.value)}
              />
              <Label>
                Telefone principal
              </Label>
              <Input
                value={telefoneFixo}
                onChange={e => setTelefoneFixo(String(e.target.value))}
              />
              <Label>
                Código do banco
              </Label>
              <Input
                value={banco}
                type='number'
                onChange={e => {
                  if (e.target.value.length > 3) {
                    return;
                  }
                  setBanco(e.target.value)
                }}
              />
              <Label>
                Agência
              </Label>
              <Input
                value={agencia}
                onChange={e => setAgencia(e.target.value)}
              />
              <Label>
                Número da conta
              </Label>
              <Input
                value={numeroConta}
                onChange={e => setNumeroConta(e.target.value)}
              />
              <Label>
                PIX
              </Label>
              <Input
                value={pix}
                onChange={e => setPix(e.target.value)}
              />
              <Label>
                Tipo PIX
              </Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={true}
                isSearchable={true}
                options={selectTipoPix}
                value={tipoPix}
                onChange={(e) => {
                  setTipoPix(e)
                }}
              />
              <Label>
                Identificação Kamino
              </Label>
              <Input
                type='number'
                value={kaminoId}
                onChange={e => setKaminoId(e.target.value)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Btn
              type="button"
              onClick={handleClickCloseAddFavModal}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Btn>
            {isLoading ?
              <Btn disabled type="button"><Spinner /></Btn> :
              <Btn
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={async () => {
                  //insOrUp( 'projStake', addStakeProjData)
                  console.log('inseriu');
                  await handleSubmit()
                }
                }
              >
                Editar
              </Btn>
            }
          </ModalFooter>
        </Mdl>
      }
    </>
  )
}

export default ModalFormEdicaoFavBordero;
